<template>
  <div>
    <b-form>
      <b-row align-v="end">
        <b-col sm="12" md="auto" lg="1">
          <label for="inline-form-input-code" class="mr-1">
            Código:
            <supply-list :items="supplyOptions" />
          </label>
          <b-form-input
            id="inline-form-input-code"
            ref="codeInput"
            v-model="$v.form.supplyCode.$model"
            size="sm"
            autocomplete="off"
            :state="$v.form.supplyCode.$dirty ? !$v.form.supplyCode.$error : null"
          ></b-form-input>
        </b-col>
        <b-col sm="12" md="auto" lg="5">
          <label for="inline-form-input-description" class="mr-1">Descripcion: </label>
          <b-form-input
            id="inline-form-input-description"
            :value="supplyDescription.name"
            size="sm"
            disabled
          ></b-form-input>
        </b-col>
        <b-col sm="12" md="auto" lg="1">
          <label for="inline-form-input-quantity" class="mr-1">Cantidad: </label>
          <b-form-input
            id="inline-form-input-quantity"
            v-model="$v.form.supplyQuantity.$model"
            :state="$v.form.supplyQuantity.$dirty ? !$v.form.supplyQuantity.$error : null"
            size="sm"
          ></b-form-input>
        </b-col>
        <b-col sm="12" md="auto" lg="1">
          <label for="inline-form-input-price" class="mr-1">P.unitario: </label>
          <b-form-input
            id="inline-form-input-price"
            v-model="$v.form.supplyPrice.$model"
            @keyup.enter="insertSupply"
            :state="$v.form.supplyPrice.$dirty ? !$v.form.supplyPrice.$error : null"
            size="sm"
          ></b-form-input>
        </b-col>
        <b-col sm="12" md="auto" lg="2">
          <label for="inline-form-input-total" class="mr-1">Total: </label>
          <b-form-input id="inline-form-input-quantity" :value="supplySubTotal" size="sm" disabled></b-form-input>
        </b-col>
        <b-col sm="12" md="auto" lg="2">
          <b-button class="float-right mt-2 ml-2" size="sm" variant="danger">Cancelar</b-button>
          <b-button
            @click="insertSupply"
            class="float-right mt-2 ml-2"
            size="sm"
            variant="primary"
            :disabled="supplyDescription === 'Digite codigo válido' ? true : false"
            >Insertar</b-button
          >
        </b-col>
      </b-row>
    </b-form>
    <b-table striped hover small foot-clone :items="items" :tbody-tr-class="rowClass" :fields="fields" class="mt-2">
      <template #cell(acciones)="data">
        <label-form :item="data.item" variant="primary" modalName="labelForm1" buttonClass="pr-2" />
        <a href="#" @click.prevent="editSupply(data.item)"><i class="fa fa-lg fa-edit text-primary mx-1"></i></a>
        <a href="#" @click.prevent="deleteSupply(data.item)"><i class="fa fa-lg fa-remove text-danger mx-1"></i></a>
      </template>
      <template #foot()="data"><span></span></template>
      <template #foot(unitario)="data"
        ><span class=""
          >Total Neto <br />
          IVA <br />
          Total</span
        ></template
      >
      <template #foot(subtotal)="data"
        >{{ total | currency }} <br />
        {{ (total * 0.19) | currency }} <br />
        {{ (total * 1.19) | currency }}</template
      >
    </b-table>
  </div>
</template>

<script>
var formatter = new Intl.NumberFormat("es-CL", {
  style: "currency",
  currency: "CLP"
});
import { required, numeric, minLength, decimal } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import SupplyList from "./SupplyList.vue";
import LabelForm from "./LabelForm.vue";

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  mixins: [validationMixin],
  components: { SupplyList, LabelForm },
  data() {
    return {
      loading: false,
      form: {
        supplyCode: null,
        supplyQuantity: null,
        supplyPrice: null
      },
      fields: [
        // "id",
        // "supplyId",
        { key: "codigo", label: "Código" },
        { key: "descripcion", label: "Descripción" },
        { key: "cantidad", label: "Cantidad" },
        { key: "unitario", label: "P.unitario" },
        { key: "subtotal", label: "Total" },
        { key: "acciones", label: "Acciones" }
      ],
      supplyOptions: [
        { code: "1", description: "Producto 1" },
        { code: "2", description: "Producto 2" },
        { code: "3", description: "Producto 3" },
        { code: "4", description: "Producto 4" },
        { code: "5", description: "Producto 5" }
      ]
    };
  },
  validations: {
    form: {
      supplyCode: {
        required
      },
      supplyQuantity: {
        required,
        numeric
      },
      supplyPrice: {
        required,
        decimal
      }
    },
    items: {
      minLength: minLength(1)
    }
  },
  filters: {
    currency(value) {
      return formatter.format(value);
    }
  },
  computed: {
    total() {
      return this.items.reduce((total, item) => total + item.subtotal, 0);
    },
    supplyDescription() {
      if (this.form.supplyCode && this.supplyOptions.length) {
        const supply = this.supplyOptions.find(
          (supply) => supply.code.toLowerCase() === this.form.supplyCode.toLowerCase()
        );
        return supply ? supply : "Digite codigo válido";
      } else {
        return "Digite codigo válido";
      }
    },
    supplySubTotal() {
      return this.form.supplyQuantity * this.form.supplyPrice;
    }
  },
  methods: {
    itemsValid() {
      const length = this.items.length;
      if (length > 0) {
        return true;
      }
      return false;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === "awesome") return "table-success";
    },
    resetForm() {
      this.form.supplyCode = null;
      this.form.supplyQuantity = null;
      this.form.supplyPrice = null;
    },
    formValid() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return false;
      }
      return true;
    },
    insertSupply() {
      if (this.formValid()) {
        this.items.push({
          supplyId: this.supplyDescription.id,
          codigo: this.supplyDescription.code,
          descripcion: this.supplyDescription.name,
          cantidad: this.form.supplyQuantity,
          unitario: this.form.supplyPrice,
          subtotal: this.supplySubTotal,
          acciones: ""
        });
        this.resetForm();
        this.$v.form.$reset();
        this.$refs.codeInput.$el.focus();
      }
    },
    deleteSupply(item) {
      this.items.splice(this.items.indexOf(item), 1);
    },
    editSupply(item) {
      this.form.supplyCode = item.codigo;
      this.form.supplyQuantity = item.cantidad;
      this.form.supplyPrice = item.unitario;
      this.items.splice(this.items.indexOf(item), 1);
    }
  },
  async mounted() {
    this.loading = true;
    // getAll Supplies
    try {
      const response = await this.$axios({
        method: "GET",
        url: `api/supplies/supply/?no_page`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.ready = true;
      this.supplyOptions = response.data;
    } catch (error) {
      console.log(error);
      this.loading = false;
      this.ready = true;
    }
  }
};
</script>

<style>
.description-input {
  width: 10.5rem !important;
}
.code-input {
  width: 50px !important;
}
</style>
